// iPhone-Druck aus der Home-Bildschirm-App (28.10.2026).
//
// Seit iOS 27.2 öffnet eine Web-App, die vom Home-Bildschirm gestartet
// wurde, auf window.print() keinen Druckdialog mehr — ohne Fehler, ohne
// Meldung. In Safari selbst geht es. Safari teilt die Sitzung der App
// aber nicht. Deshalb: mit der Sitzung der App ein kurzlebiges
// Druck-Zeichen holen (api/druck/zeichen.php, 10 Minuten, eine
// Bestellung, nur Lesen) und die Druckseite damit in Safari öffnen.

import { apiFetch } from './api';

type NavigatorMitStandalone = Navigator & { standalone?: boolean };

/**
 * Läuft das Tracking als Home-Bildschirm-App auf einem iPhone?
 *
 * Bewusst NUR iPhone/iPod: Gemeldet ist der Fehler am iPhone. Am iPad
 * und unter Android druckt die App, wie sie ist — dort soll sich nichts
 * ändern, was funktioniert.
 */
export function istIosHomeApp(
  nav: NavigatorMitStandalone = navigator,
  medien: ((q: string) => { matches: boolean }) | undefined = typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function'
    ? (q) => window.matchMedia(q)
    : undefined
): boolean {
  const iphone = /iPhone|iPod/.test(nav.userAgent);
  if (!iphone) return false;
  if (nav.standalone === true) return true;
  return medien?.('(display-mode: standalone)').matches ?? false;
}

export type DruckArt = 'zettel' | 'lieferschein';

/** Druck-Zeichen holen und die absolute Adresse der Druckseite bauen. */
export async function druckAdresseHolen(
  bestellnr: string,
  art: DruckArt,
  variante?: string
): Promise<string> {
  const r = await apiFetch<{ zeichen: string; minuten: number }>('/druck/zeichen.php', {
    method: 'POST',
    body: JSON.stringify({ bestellnr, art, variante })
  });
  return `${window.location.origin}/drucken/${encodeURIComponent(r.zeichen)}`;
}

/**
 * Adresse in Safari öffnen statt in der App. `x-safari-https://…` ist
 * das Schema, mit dem iOS (ab 17) eine Adresse ausdrücklich an Safari
 * übergibt; ein gewöhnlicher Link bliebe in der App.
 */
export function inSafariOeffnen(adresse: string): void {
  window.location.href = `x-safari-${adresse}`;
}
